/** @format */

import EdilentWorkerApi from '@model/api';
import Validator from '@croco/validator';
import di from "dependency-injection";

/**
 *
 * @package     edilent-worker
 */
class BasicInformationApi extends EdilentWorkerApi {
    /**
     * コンストラクタ
     *
     * @access public
     * @return void
     */
    constructor() {
        super('info');
        this.isRegistered = false;
        this._clear();
        this._registerEvent();
    }

    /**
     * バリデーションの取得
     *
     * @access public
     * @return void
     */
    getValidation(name) {
        let validation = new Map([
            ['family_name', {required: true, validate: false}],
            ['last_name', {required: true, validate: false}],
            ['family_kana', {required: true, validate: false, mbstring: true}],
            ['last_kana', {required: true, validate: false, mbstring: true}],
            ['birthday', {required: true, validate: true}],
            ['zip', {required: true, validate: true, numeric: true}],
            ['address1', {required: true, validate: true}],
            ['mynumber', {required: true, validate: true, numeric: true}],
            ['invoice_provider_number_body', {required: false, validate: false}],
        ]);
        if (validation.has(name)) {
            return validation.get(name);
        }

        return {required: false, validate: false};
    }

    /**
     * 変数の初期化
     *
     * @access private
     * @return void
     */
    _clear() {
        this.item = new Validator({
            family_name: '',
            last_name: '',
            family_kana: '',
            last_kana: '',
            birthday: '2000-01-01',
            zip: '',
            sex: '1',
            address1: '',
            address2: '',
            mynumber: '',
            identity_type: "driver-lisence",
            invoice_provider_number_body: '',
            invoice_provider_state: 'no',
        });
        this.invoice_provider_number_prefix = 'T'
        this.file1 = ''
        this.file2 = ''
        this.file3 = ''
        this.file4 = ''
        this.fieldsAlert = true;


    }

    /**
     * イベントの登録
     *
     * @access private
     * @return void
     */
    _registerEvent() {
        this.on('fetch', () => {
            this._fetch();
        });
        this.on('save', () => {
            this._save();
        });
    }

    hasFields() {
        let keys = this.item._keys;
        let array = [];
        for (let idx in keys) {
            if (this.item[keys[idx]]) {
                array.push(this.item[keys[idx]]);
            }
        }
        this.fieldsAlert = (0 === array.length);
        return this.fieldsAlert;
    }

    /**
     * 指定した制作実績の取得
     *
     * @access private
     * @return void
     */
    async _fetch() {
        this._clear();

        let item = await this.request('basicInformation', 'fetch');
        this.isRegistered = !!item.family_name;
        let exists_invoice_provider_number_body = false;
        for (const key in item) {

            const value = ((key === "invoice_provider_state") && (item[key] === "unknown")) ? "no" : item[key];

            if (key === 'address2') {
                this.item.set(key, item[key], {validate: false});
            } else if (key === "invoice_provider_number_body") {
                //number_bodyはstateがyes以外の場合は採用しない。number_bodyがあるのはyes（発行事業者）だけのため
                const number_body = (item["invoice_provider_state"] !== "yes") ? "" : value;
                this.item.set(key, number_body, {required: false, validate: false});
                exists_invoice_provider_number_body = true;
            } else if ((key === "invoice_provider_number_prefix") || (key === "invoice_provider_number")) {
                //これらの項目は送られてきてもスルーする。riotコンポーネント側で常に自動生成する項目のため
            } else {
                this.item.set(key, value, {required: true, validate: true});
            }

        }
        this.hasFields();
        this.trigger('update');
    }

    /**
     * 基本情報の登録/更新
     *
     * @access private
     * @return void
     */
    async _save() {

        this.enable = this.item.validate();
        if (!this.enable) {
            this.trigger('update');
            return;
        }

        if (this.hasFields()) {
            this.trigger('update');
            return;
        }
        let data = new FormData();
        for (const key in this.item) {
            if (this.item.hasOwnProperty(key) && this.item[key]) {
                data.set(key, this.item[key])
            } else {
                data.set(key, "")
            }
        }

        if (!this.item.hasOwnProperty("invoice_provider_number_body")) {
            data.set("invoice_provider_number_body", "");
        }

        data.set('file1', this.file1);
        data.set('file2', this.file2);
        data.set('file3', this.file3);
        data.set('file4', this.file4);

        //data.set('invoice_provider_number', this.invoice_provider_number);
        //data.set('invoice_provider_state', this.invoice_provider_state);
        data.set('invoice_provider_number_prefix', this.invoice_provider_number_prefix);

        try {
            await this.request('basicInformation', 'save', data);
            di.toast.push(`登録・変更申請をしました`, "success");
            if (!this.isRegistered) {
                this.isRegistered = true;
                window.analytics.event("unlock_achievement", {
                    achievement_id: "basic_info_first_application",
                });
            }
            di.router.push("/info/basic-information-application-confirm");
        } catch (e) {
            di.toast.push(e, 'negative');
        }
    }
}

const basicInformationApi = new BasicInformationApi();

export default basicInformationApi;
